import React, { Component } from 'react';

export default class Loading extends Component {
  render() {
    return (
      <div className="unit__loading">
        <div className="lds-ellipsis">
          <div> </div>
          <div> </div>
          <div> </div>
          <div> </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/custom/Loading.js